import type { ReactNode } from 'react';

/**
 * El pastel del cartel de RR.HH., en línea: sin imagen que cargar, con los
 * colores de Kn·Blog. Lo usan la pestaña de cumpleaños y la felicitación.
 */
export const CakeIcon = ({ className }: { readonly className: string | undefined }): ReactNode => (
  <svg className={className} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
    <path d="M32 6c3 4 3 7 0 9-3-2-3-5 0-9z" fill="var(--blog-confetti-1)" />
    <rect x="29" y="15" width="6" height="12" rx="2" fill="var(--blog-tile-2)" />
    <rect x="10" y="27" width="44" height="12" rx="4" fill="var(--blog-tile-5)" />
    <path
      d="M10 33c4 4 7 4 11 0s7-4 11 0 7 4 11 0 7-4 11 0"
      stroke="var(--blog-on-tile)"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
    />
    <rect x="6" y="39" width="52" height="15" rx="4" fill="var(--blog-tile-1)" />
    <rect x="2" y="54" width="60" height="5" rx="2.5" fill="var(--blog-tile-6)" />
  </svg>
);
